import { Component, OnInit, Input } from '@angular/core';
import { HtmlParser } from '@angular/compiler';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    standalone: false
})
export class MessageComponent implements OnInit {

  @Input() successMessage: boolean;
  @Input() messageTitle: HtmlParser;
  @Input() message: HtmlParser;

  constructor() { }

  ngOnInit(): void { }

}
